export default [
	{
		path: '/pages/edit/:id',
		name: 'pages-edit',
		component: () => import(
			/* webpackChunkName: "pages-edit" */ './../views/Pages/Edit.vue'
		),
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/pages/add',
		name: 'pages-add',
		component: () => import(
			/* webpackChunkName: "pages-add" */ './../views/Pages/Add.vue'
		),
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/pages',
		name: 'pages',
		component: () => import(
			/* webpackChunkName: "pages" */ './../views/Pages/List.vue'
		),
		meta: {
			requiresAuth: true
		}
	}
];